<template>
  <!--begin::languagesIndex-->
  <div class="row gy-5 g-xl-8">
    <LanguagesIndex
      widget-classes="card-xxl-stretch mb-5 mb-xl-8"
    ></LanguagesIndex>
  </div>
  <!--end::languagesIndex-->
</template>

<script lang="js">
import { defineComponent, onMounted } from "vue";
import LanguagesIndex from "@/components/system/LanguagesIndex.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "LanguagesView",
  components: {
    LanguagesIndex
  },
  mounted() {
    setCurrentPageTitle("Languages");
  }
});
</script>
